import ConfigNode from 'Model/ConfigNode'
import { namespaces, branch } from 'Model/constants'

class Namespaces extends ConfigNode
  @className = 'Namespaces'

  constructor: ->
    super('namespaces')

  enabled: ->
    @get('enabled')

  updateEnabled: (value) ->
    @set('enabled', value)
    @save()

  map: ->
    _.reduce(@get('value').split("#!#"), (acc, val) ->
      [key, val] = val.split('#?#')
      { acc..., [key]: val }
    , {})

  updateMap: (map, params = {}) ->
    @set('value', _.map(map, (val, key) ->
      "#{key}#?##{val}"
    ).join('#!#'))
    @save(params)

  reset: (params = {}) ->
    @updateMap(nameSpaces, params)

  @load: ->
    super('namespaces', @)

export default Namespaces
